import { tracked } from '@glimmer/tracking';

import FilterSortGoalTeams from 'webapp/models-custom/filter-sort/goal-teams';

export default class FilterSortGoalTeamsInGrid extends FilterSortGoalTeams {
	@tracked override viewId = 'grid';
	override itemDomSelector = 'li.filter-sort-item';
}
